import script from "./MaterialSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialSelect.vue?vue&type=script&setup=true&lang=js"

import "./MaterialSelect.vue?vue&type=style&index=0&id=13b59f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b59f3c"]])

export default __exports__